import { render, staticRenderFns } from "./EditContactModal.vue?vue&type=template&id=2b5613fa&scoped=true"
import script from "./EditContactModal.vue?vue&type=script&lang=ts"
export * from "./EditContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5613fa",
  null
  
)

export default component.exports